import appState from "../state/State";

export const appReducer = (state = appState, action) => {
  switch (action.type) {
    case "SET_USER": {
      return {
        ...state,
        user: action.value,
      };
    }
    case "SET_SPLITWISE_USER": {
      return {
        ...state,
        splitwiseUser: action.value,
      };
    }
    case "SET_API_CACHE": {
      return {
        ...state,
        apiCache: {
          ...state.apiCache,
          [action.key]: action.value,
        },
      };
    }
    case "CLEAR_API_CACHE": {
      if (action.key) {
        const updatedCache = { ...state.apiCache };
        delete updatedCache[action.key];
        return {
          ...state,
          apiCache: updatedCache,
        };
      }
      return {
        ...state,
        apiCache: {},
      };
    }
    case "HYDRATE_API_CACHE": {
      return {
        ...state,
        apiCache:
          action.value && typeof action.value === "object" ? { ...action.value } : state.apiCache,
      };
    }
    case "REMOVE_API_CACHE_KEYS": {
      const keys = action.keys;
      if (!Array.isArray(keys) || keys.length === 0) {
        return state;
      }
      const next = { ...state.apiCache };
      for (const k of keys) {
        delete next[k];
      }
      return { ...state, apiCache: next };
    }
    default:
      return state;
  }
};
